<template>
  <div class="balance"
       :class="[background]">
    <div class="balance-inner">
      <div class="balance--total">
        <div>
          <span v-text="title"></span>
          <span v-if="keysOfBalance.length"
                class="balance--total--price">{{sign + ' ' + formatedPrice(total)}}</span>
        </div>
      </div>
      <div class="balance--total2"
           v-if="keysOfBalance.length">
        <p>Solde Sofradom :
          <span v-text="formatedPrice(balance.sofradom)"></span>
        </p>
        <p>Solde SDM :
          <span>{{formatedPrice(balance.sdm)}}</span>
        </p>
        <p>Solde ABC + :
          <span>{{formatedPrice(balance.abc_plus)}}</span>
        </p>
      </div>
      <div v-else
           class="balance--total2"
           style="display: block;">
        <div class="progress-circle">
          <div class="progress-circle-indeterminate progress-circle-info"></div>
        </div>
      </div>
    </div>
    <div v-if="balance" class="updated-at">
      <div>
        <p>Mise à jour : {{ balance.date | moment-date-time }}</p>
        <p>
          Autorisation(s) en attente de capture : 
          <span :class="{ 'text-warning': balance.pending_authorizations > 0 }">
            {{ formatedPrice(balance.pending_authorizations) }}
          </span>
        </p>
      </div>
      <i v-if="balance"
         class="fa fa-refresh"
         title="Rafraîchir le solde"
         @click="fetchBalance({'customerId': $route.params.id, 'refresh': 1})"></i>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import '~pages_sass/_var.scss';

  .color-normal {
    background: #eb7;
  }

  .color-danger {
    background: $color-danger;
  }

  .color-success {
    background: $color-success;
  }

  .balance {
    padding: 20px;
    .balance-inner{
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      @media screen and (max-width: 1399px) {
        flex-direction: column;
        align-items: center;
        .balance--total {
          width: 100%;
          text-align: left;
          border-right: none;
          border-bottom: 1px solid rgba(255, 255, 255, 0.4);
          padding: 0 0 20px 0;
          align-self: flex-start;
          align-items: flex-start;
        }
        .balance--total2 {
          padding: 20px 0;
          width: 100%;
        }
      }
      @media screen and (max-width: 991px) {
        .balance--total {
          align-self: center;
          align-items: center;
        }
      }
    }
    .updated-at
    {
      position: relative;
      padding-top: 10px;
      border-top: 1px solid rgba(255, 255, 255, 0.4);
      font-size: 13px;
      font-weight: bold;
      color: #fff;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      p {
        font-weight: bold;
        margin: 0;
      }
      i {
        cursor: pointer;
        padding-top: 5px;
      }
    }
  }

  .balance--total {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 50%;
    border-right: 1px solid rgba(255, 255, 255, 0.4);
    padding-right: 10px;
    div {
      display: flex;
      flex-direction: column;
    }
    span {
      color: #fff;
      line-height: 16px;
    }
  }

  .balance--total--price {
    font-size: 36px;
    line-height: 28px !important;
  }

  .balance--total2 {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0;
    padding-left: 10px;
    p {
      font-size: 12px;
      color: #fff;
      display: flex;
      justify-content: space-between;
      width: 100%;
      max-width: 250px;
      margin: 0;
      span {
        font-weight: 700;
      }
    }
  }
</style>

<script type="text/babel">
  import { mapActions, mapState } from "vuex"

  export default {

    methods: {
      ...mapActions("customer", ["fetchBalance"]),

      formatedPrice (price) {
        if (!this.keysOfBalance.length)
          return null
        return (price / 100).toFixed(2) + ' €'
      },

      balanceOf (key) {
        return this.balance[key]
      },
    },

    computed: {
      ...mapState("customer", ["balance"]),

      keysOfBalance () {
        return _.keys(this.balance)
      },

      background () {
        if (_.isNull(this.total) || this.total === 0)
          return 'color-success'
        return this.total < 0 ? 'color-success' : 'color-danger'
      },

      total () {
        if (!this.keysOfBalance.length)
          return null
        return this.balance.total
      },

      title () {
        if (_.isNull(this.total))
          return null

        return this.total === 0 ? "Solde Nul" :
          this.total > 0 ? "Le client nous doit" : "Nous devons au client"
      },

      sign () {
        if (this.total === 0)
          return ''
        return this.total >= 0 ? '+' : ''
      },

    },

    created () {
      this.fetchBalance({"customerId": this.$route.params.id, "refresh": 0})
    }
  }
</script>



// WEBPACK FOOTER //
// client/components/Customer/InformationsContent/Balance.vue